import usingServiceAdvantage from './usingServiceAdvantage';
import frequentlyAskedQuestions from './fullservice-frequentlyAskedQuestions';
const SectionContent = {
  topSection: {
    en: {
      title: 'Full Service Restaurant POS System',
      description: `Take your tableside service to the next level with Chowbus' Full Service Restaurant POS System!`,
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty.png`,
      // youtubeVideoId: '4rNgi9oZxwM',
    },
    zh: {
      title: '堂食餐厅',
      description: 'Chowbus POS可以显著提升堂食餐厅的运营效率! ',
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty.png`,
      // youtubeVideoId: '4rNgi9oZxwM',
    },
  },
  everythingNeedInOnePOSSystem: {
    en: {
      title: 'Recommended Products for Full Service Restaurants',
    },
    zh: {
      title: '推荐使用的POS产品',
    },
  },
  usingServiceAdvantage: {
    ...usingServiceAdvantage,
  },
  frequentlyAskedQuestions: {
    ...frequentlyAskedQuestions,
  },
};

export default SectionContent;
